<div class="nf-settings-wrap" id="brandingPage">
  <div class="nf-settings">
    <!-- Appearance -->
    <div class="nf-panel">
      <div class="nf-panel__header">
        <div class="nf-panel__heading">
          <span class="nf-panel__title">Appearance</span>
        </div>
      </div>

      <div class="nf-actions-list">
        <div class="nf-action-item">
          <div class="nf-setting-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="9" />
              <path d="M12 3a9 9 0 0 1 0 18Z" fill="currentColor" stroke="none" />
            </svg>
          </div>
          <div class="nf-action-item__text">
            @if (featureService.isCloudZiti) {
              <span class="nf-action-item__title">Theme</span>
              <span class="nf-action-item__desc">Match your device, or always use light or dark.</span>
            } @else {
              <span class="nf-action-item__title">Dark Mode</span>
              <span class="nf-action-item__desc">Use a darker theme for low-light environments.</span>
            }
          </div>
          @if (featureService.isCloudZiti) {
            <div class="nf-picker nf-setting-control" (keydown.escape)="closeThemeMenu()">
              <button
                type="button"
                class="nf-picker__trigger"
                [class.is-open]="themeMenuOpen"
                aria-haspopup="listbox"
                [attr.aria-expanded]="themeMenuOpen"
                (click)="toggleThemeMenu()"
                id="DarkModeSetting">
                <span class="nf-picker__value">
                  <ng-container [ngTemplateOutlet]="themeIcon" [ngTemplateOutletContext]="{ $implicit: selectedThemeOption.value }"></ng-container>
                  <span>{{ selectedThemeOption.label }}</span>
                </span>
                <svg class="nf-picker__chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="m6 9 6 6 6-6" />
                </svg>
              </button>

              @if (themeMenuOpen) {
                <div class="nf-picker__backdrop" (click)="closeThemeMenu()"></div>
                <ul class="nf-picker__menu" role="listbox" aria-label="Theme">
                  @for (opt of themeOptions; track opt.value) {
                    <li>
                      <button
                        type="button"
                        class="nf-picker__option"
                        role="option"
                        [class.is-selected]="opt.value === darkModeSetting"
                        [attr.aria-selected]="opt.value === darkModeSetting"
                        (click)="selectTheme(opt.value)">
                        <ng-container [ngTemplateOutlet]="themeIcon" [ngTemplateOutletContext]="{ $implicit: opt.value }"></ng-container>
                        <span class="nf-picker__option-label">{{ opt.label }}</span>
                        @if (opt.value === darkModeSetting) {
                          <svg class="nf-picker__check" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M20 6 9 17l-5-5" />
                          </svg>
                        }
                      </button>
                    </li>
                  }
                </ul>
              }
            </div>

            <ng-template #themeIcon let-value>
              @switch (value) {
                @case ('auto') {
                  <svg style="color: #14b8a6" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <rect width="20" height="14" x="2" y="3" rx="2" />
                    <line x1="8" x2="16" y1="21" y2="21" /><line x1="12" x2="12" y1="17" y2="21" />
                  </svg>
                }
                @case ('false') {
                  <svg style="color: #f5a623" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="12" cy="12" r="4" />
                    <path d="M12 2v2" /><path d="M12 20v2" /><path d="m4.93 4.93 1.41 1.41" /><path d="m17.66 17.66 1.41 1.41" />
                    <path d="M2 12h2" /><path d="M20 12h2" /><path d="m6.34 17.66-1.41 1.41" /><path d="m19.07 4.93-1.41 1.41" />
                  </svg>
                }
                @case ('true') {
                  <svg style="color: #8b5cf6" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z" />
                  </svg>
                }
              }
            </ng-template>
          } @else {
            <button
              type="button"
              role="switch"
              [attr.aria-checked]="brandingService.darkModeEnabled"
              class="nf-switch"
              [class.is-on]="brandingService.darkModeEnabled"
              (click)="toggleDarkMode()"
              id="toggleButtonDarkMode">
              <span class="nf-switch__knob"></span>
            </button>
          }
        </div>
      </div>
    </div>

    <!-- Defaults -->
    @if (featureService.isCloudZiti) {
      <div class="nf-panel">
        <div class="nf-panel__header">
          <div class="nf-panel__heading">
            <span class="nf-panel__title">Defaults</span>
          </div>
        </div>

        <div class="nf-actions-list">
          @if (authorizationService.canListNetworks()) {
            <div class="nf-action-item">
              <div class="nf-setting-icon" aria-hidden="true">
                <span class="icon-networks"></span>
              </div>
              <div class="nf-action-item__text">
                <span class="nf-action-item__title">Default Network</span>
                <span class="nf-action-item__desc">The network to open when you sign in.</span>
              </div>
              <div class="nf-picker nf-setting-control nf-setting-control--wide" (keydown.escape)="closeNetworkMenu()">
                <button
                  type="button"
                  class="nf-picker__trigger"
                  [class.is-open]="networkMenuOpen"
                  aria-haspopup="listbox"
                  [attr.aria-expanded]="networkMenuOpen"
                  (click)="toggleNetworkMenu()"
                  id="DefaultNetworkTrigger">
                  <span class="nf-picker__value">
                    @if (defaultNetwork?.id) {
                      <span class="nf-net-dot" [ngClass]="'is-' + defaultNetworkDotClass" aria-hidden="true"></span>
                      <span>{{ defaultNetwork.name }}</span>
                    } @else {
                      <span>No default network</span>
                    }
                  </span>
                  <svg class="nf-picker__chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="m6 9 6 6 6-6" />
                  </svg>
                </button>

                @if (networkMenuOpen) {
                  <div class="nf-picker__backdrop" (click)="closeNetworkMenu()"></div>
                  <div class="nf-net-menu">
                    <app-network-picker
                      [networks]="networks"
                      [currentNetworkId]="defaultNetwork?.id"
                      [showHeader]="false"
                      [showClear]="true"
                      clearLabel="No default network"
                      (networkChange)="onDefaultNetworkPicked($event)"
                      (closed)="closeNetworkMenu()">
                    </app-network-picker>
                  </div>
                }
              </div>
            </div>
          }

          <div class="nf-action-item">
            <div class="nf-setting-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect width="7" height="7" x="3" y="3" rx="1" />
                <rect width="7" height="7" x="14" y="3" rx="1" />
                <rect width="7" height="7" x="14" y="14" rx="1" />
                <rect width="7" height="7" x="3" y="14" rx="1" />
              </svg>
            </div>
            <div class="nf-action-item__text">
              <span class="nf-action-item__title">Default App</span>
              <span class="nf-action-item__desc">The app to open when you sign in.</span>
            </div>
            <div class="nf-picker nf-setting-control nf-setting-control--wide" (keydown.escape)="closeAppMenu()">
              <button
                type="button"
                class="nf-picker__trigger"
                [class.is-open]="appMenuOpen"
                aria-haspopup="listbox"
                [attr.aria-expanded]="appMenuOpen"
                (click)="toggleAppMenu()"
                id="Providers">
                <span class="nf-picker__value">
                  @if (selectedAppOption) {
                    <i class="{{ selectedAppOption.icon }}" aria-hidden="true"></i>
                    <span>{{ selectedAppOption.name }}</span>
                  } @else {
                    <span>Select an app</span>
                  }
                </span>
                <svg class="nf-picker__chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="m6 9 6 6 6-6" />
                </svg>
              </button>

              @if (appMenuOpen) {
                <div class="nf-picker__backdrop" (click)="closeAppMenu()"></div>
                <ul class="nf-picker__menu" role="listbox" aria-label="Default app">
                  @for (app of visibleAppOptions; track app.id) {
                    <li>
                      <button
                        type="button"
                        class="nf-picker__option"
                        role="option"
                        [class.is-selected]="app.id === defaultAppId"
                        [attr.aria-selected]="app.id === defaultAppId"
                        (click)="selectApp(app.id)">
                        <i class="{{ app.icon }}" aria-hidden="true"></i>
                        <span class="nf-picker__option-label">{{ app.name }}</span>
                        @if (app.id === defaultAppId) {
                          <svg class="nf-picker__check" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M20 6 9 17l-5-5" />
                          </svg>
                        }
                      </button>
                    </li>
                  }
                </ul>
              }
            </div>
          </div>
        </div>
      </div>
    }

    <!-- Preferences -->
    @if (authorizationService.canListOrganizations() || featureService.isCloudZiti) {
      <div class="nf-panel">
        <div class="nf-panel__header">
          <div class="nf-panel__heading">
            <span class="nf-panel__title">Preferences</span>
          </div>
        </div>

        <div class="nf-actions-list">
          @if (authorizationService.canListOrganizations()) {
            <div class="nf-action-item">
              <div class="nf-setting-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z" />
                </svg>
              </div>
              <div class="nf-action-item__text">
                <span class="nf-action-item__title">Power User</span>
                <span class="nf-action-item__desc">Show advanced power-user features across the console.</span>
              </div>
              <button
                type="button"
                role="switch"
                [attr.aria-checked]="featureService.powerUserEnabled"
                class="nf-switch"
                [class.is-on]="featureService.powerUserEnabled"
                (click)="togglePowerUserSetting()"
                id="toggleButtonPowerUserSettings">
                <span class="nf-switch__knob"></span>
              </button>
            </div>
          }

          @if (!featureService.isCloudZiti && authorizationService.canListOrganizations()) {
            <div class="nf-action-item">
              <div class="nf-setting-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <rect width="18" height="18" x="3" y="3" rx="2" />
                  <path d="M9 3v18" />
                </svg>
              </div>
              <div class="nf-action-item__text">
                <span class="nf-action-item__title">New Navigation</span>
                <span class="nf-action-item__desc">Use the redesigned side navigation. Turn off to opt out.</span>
              </div>
              <button
                type="button"
                role="switch"
                [attr.aria-checked]="!featureService.disableNewNavigation"
                class="nf-switch"
                [class.is-on]="!featureService.disableNewNavigation"
                (click)="toggleSideNavigationSetting()"
                id="toggleSideNavSettings">
                <span class="nf-switch__knob"></span>
              </button>
            </div>
          }

          @if (featureService.isCloudZiti) {
            <div class="nf-action-item">
              <div class="nf-setting-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83Z" />
                  <path d="M2 12a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 12" />
                  <path d="M2 17a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 17" />
                </svg>
              </div>
              <div class="nf-action-item__text">
                <span class="nf-action-item__title">Managed Entities</span>
                <span class="nf-action-item__desc">Show entities created and managed by the NetFoundry platform.</span>
              </div>
              <button
                type="button"
                role="switch"
                [attr.aria-checked]="featureService.showManagedEntities"
                class="nf-switch"
                [class.is-on]="featureService.showManagedEntities"
                (click)="toggleManagedEntitiesSetting()"
                id="toggleManagedEntitiesSettings">
                <span class="nf-switch__knob"></span>
              </button>
            </div>

            @if (authorizationService.isSupportUser() || authorizationService.isSupportReadOnlyUser()) {
              <div class="nf-action-item">
                <div class="nf-setting-icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M14 2v6a2 2 0 0 0 .245.96l5.51 10.08A2 2 0 0 1 18 22H6a2 2 0 0 1-1.755-2.96l5.51-10.08A2 2 0 0 0 10 8V2" />
                    <path d="M6.453 15h11.094" />
                    <path d="M8.5 2h7" />
                  </svg>
                </div>
                <div class="nf-action-item__text">
                  <span class="nf-action-item__title">Beta Features</span>
                  <span class="nf-action-item__desc">Get early access to new features ahead of general release.</span>
                </div>
                <button
                  type="button"
                  role="switch"
                  [attr.aria-checked]="featureService.betaFeaturesEnabled"
                  class="nf-switch"
                  [class.is-on]="featureService.betaFeaturesEnabled"
                  (click)="toggleBetaFeaturesSetting()"
                  id="toggleButtonBetaFeatures">
                  <span class="nf-switch__knob"></span>
                </button>
              </div>

              @if (featureService.zitiOverlayAvailable) {
                <div class="nf-action-item">
                  <div class="nf-setting-icon" aria-hidden="true">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <rect x="16" y="16" width="6" height="6" rx="1" />
                      <rect x="2" y="16" width="6" height="6" rx="1" />
                      <rect x="9" y="2" width="6" height="6" rx="1" />
                      <path d="M5 16v-3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3" />
                      <path d="M12 12V8" />
                    </svg>
                  </div>
                  <div class="nf-action-item__text">
                    <span class="nf-action-item__title">Secure Connection</span>
                    <span class="nf-action-item__desc">Connect from the browser to the network controller over Ziti.</span>
                  </div>
                  <button
                    type="button"
                    role="switch"
                    [attr.aria-checked]="featureService.zitiOverlayEnabled"
                    class="nf-switch"
                    [class.is-on]="featureService.zitiOverlayEnabled"
                    (click)="toggleZitiOverlaySetting()"
                    id="toggleButtonZitiOverlay">
                    <span class="nf-switch__knob"></span>
                  </button>
                </div>
              }
            }
          }
        </div>
      </div>
    }

    <!-- Support -->
    @if (authorizationService.isSupportUser() || authorizationService.isSupportReadOnlyUser()) {
      <div class="nf-panel">
        <div class="nf-panel__header">
          <div class="nf-panel__heading">
            <span class="nf-panel__title">Support</span>
          </div>
        </div>

        <div class="nf-actions-list">
          <div class="nf-action-item">
            <div class="nf-setting-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M2.586 17.414A2 2 0 0 0 2 18.828V21a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h1a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h.172a2 2 0 0 0 1.414-.586l.814-.814a6.5 6.5 0 1 0-4-4z" />
                <circle cx="16.5" cy="7.5" r=".5" fill="currentColor" />
              </svg>
            </div>
            <div class="nf-action-item__text">
              <span class="nf-action-item__title">Access Token</span>
              <span class="nf-action-item__desc">Copy your access token (JWT) for support and debugging.</span>
            </div>
            <button (click)="copyToClipboard()" class="nf-btn nf-btn--secondary" id="CopyJwtButton">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <rect width="8" height="4" x="8" y="2" rx="1" ry="1" />
                <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" />
              </svg>
              Copy JWT
            </button>
          </div>
        </div>
      </div>
    }
  </div>

  @if (isLoading) {
    <app-loader [isLoading]="isLoading" class="load-indicator" id="userSettingPageLoader"></app-loader>
  }
</div>
